import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
import { mapActions } from "vuex";
export default {
  name: "im-monitor",
  mixins: [userPopMixin],
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        type: ""
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 表单
      typeList: [{
        id: 3,
        name: "诈骗"
      }, {
        id: 2,
        name: "拉客"
      }, {
        id: 1,
        name: "白嫖"
      }],
      form: {},
      dialogVisible: false,
      // 弹窗状态
      rules: {
        type: [{
          required: true,
          message: "请选择类别",
          trigger: "blur"
        }],
        keyword: [{
          required: true,
          message: "请输入关键词",
          trigger: "blur"
        }],
        remark: [{
          required: true,
          message: "请输入备注",
          trigger: "blur"
        }]
      },
      pageDB: null
    };
  },
  watch: {
    searchForm: {
      handler: function handler(nVal) {
        if (this.pageDB) {
          this.pageDB.set("searchFormMonitor", {
            type: nVal.type,
            isHighRisk: nVal.isHighRisk
          }).write();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            if (data !== null && data !== void 0 && data.searchFormMonitor) {
              _this.searchForm = _objectSpread(_objectSpread({}, data.searchFormMonitor), {}, {
                pn: 1,
                ps: 20
              });
            }
            _this.getData();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["databasePage", "databasePageClear"])), {}, {
    changeSearchType: function changeSearchType() {
      if (this.searchForm.type === 2 || this.searchForm.type === 1) {
        this.searchForm.isHighRisk = null;
      }
      this.getData('search');
    },
    getImMonitorRiskByKeyword: function getImMonitorRiskByKeyword(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(row === 'all')) {
                _context3.n = 1;
                break;
              }
              _this2.tableData.forEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
                  var res;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        item.loading = true;
                        _context2.n = 1;
                        return _this2.$api.getImMonitorRiskByKeyword({
                          id: item.id,
                          keyword: item.keyword
                        });
                      case 1:
                        res = _context2.v;
                        item.loading = false;
                        item.risk = res.data;
                      case 2:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context3.n = 3;
              break;
            case 1:
              row.loading = true;
              _context3.n = 2;
              return _this2.$api.getImMonitorRiskByKeyword({
                id: row.id,
                keyword: row.keyword
              });
            case 2:
              res = _context3.v;
              row.loading = false;
              row.risk = res.data;
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    goImSearch: function goImSearch(row) {
      window.open("#/im/search?keyword=".concat(row.keyword));
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    reset: function reset() {
      this.searchForm = {
        pn: 1,
        ps: 20,
        type: ''
      };
      this.$refs.table.clearSort();
      this.getData('search');
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var param, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              param = _objectSpread({}, _this3.searchForm);
              if (!param.keyword) {
                delete param.keyword;
              }
              _this3.tableLoading = true;
              _context4.n = 1;
              return _this3.$api.getImMonitorKeywordsList(param);
            case 1:
              res = _context4.v;
              res.data.list.forEach(function (item) {
                item.loading = false;
              });
              _this3.tableData = res.data.list;
              _this3.total = res.data.totalSize;
              _this3.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!_this4.form.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this4.$api.updateImMonitorKeyword(_this4.form);
            case 1:
              _context5.n = 3;
              break;
            case 2:
              _context5.n = 3;
              return _this4.$api.addImMonitorKeyword(_this4.form);
            case 3:
              // 操作上报
              _this4.$operationLog.push({
                operationType: "text",
                code: _this4.form.id ? "edit" : "add",
                detailBatchNo: "\u5173\u952E\u8BCD\uFF1A".concat(_this4.form.keyword)
              });
              _this4.dialogVisible = false;
              _this4.form = {};
              _this4.getData();
            case 4:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    changeType: function changeType() {
      if (this.form.type != 3) {
        this.form.isHighRisk = false;
      }
    },
    changeTable: function changeTable(e) {
      var prop = e.prop,
        order = e.order;
      if (order) {
        if (prop === "riskUpdateTime" || prop === "hitCountLastThreeDays") {
          this.searchForm.sortField = prop;
        }
        if (order === "descending") {
          this.searchForm.sortOrder = "desc";
        } else if (order === "ascending") {
          this.searchForm.sortOrder = "asc";
        }
      } else {
        this.searchForm.sortOrder = null;
        this.searchForm.sortField = null;
      }
      this.getData("search");
    },
    deleteImKeyword: function deleteImKeyword(row) {
      var _this5 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this5.$api.deleteImMonitorKeyword({
                id: row.id
              });
            case 1:
              // 操作上报
              _this5.$operationLog.push({
                operationType: "text",
                code: "restore",
                detailBatchNo: "\u5173\u952E\u8BCD\uFF1A".concat(row.keyword)
              });
              _this5.$message.success("操作成功");
              _this5.getData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    }
  })
};